import { useEffect } from "react";
import { useNavigate } from "react-router";

import { useEnvironmentUnsafe } from "@/common/contexts/EnvironmentContext";
import { EnvironmentUrl } from "@reflag/shared/urls";

export default function GoToHome() {
  const { user, org, env } = useEnvironmentUnsafe() ?? {};
  const navigate = useNavigate();

  // Force a server request when redirecting to allow
  // for backend analytics calls
  useEffect(() => {
    if (!user?.isReflagAdmin && org?.suspendedAt) {
      // Early exit out of page reloads if the org is suspended
      window.location.assign("/org-suspended");
    } else if (env) {
      navigate(EnvironmentUrl(env), { replace: true });
    } else if (org?.apps.length === 0) {
      window.location.assign("/apps/new");
    } else {
      window.location.assign("/get-started");
    }
  }, [user, env, org, navigate]);

  return null;
}
